import React, {useEffect} from 'react'
import styled from '@emotion/styled'
import {
    TrialButton,
    StyledButtonContainer
} from 'views/PreLogin/styled'
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'utils/constants'
import {PROJECT_STORE_KEY} from 'context/project-context';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 30px;
`
export const StyledTitle = styled.h1`
    font-size: 16px;
    color: gray;
    text-align: center;
    margin-bottom: 10px;
`
export const StyledSubTitle = styled.h2`
    color: #2747A8;
    font-size: 14px;
    margin-left: 5px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`

const isSafari = () => {
    const ua = navigator?.userAgent?.toLowerCase();
    const vendor = navigator?.vendor?.toLowerCase();
    return vendor.includes('apple') && ua.includes("safari");
}

function ScanResult({ form, scanDetails, token }) 
{
    const onViewResult = () => {
        if(token && scanDetails){
            window.localStorage.setItem(ACCESS_TOKEN_KEY, token.access_token);
            window.localStorage.setItem(REFRESH_TOKEN_KEY, token.refresh_token);
            window.parent.location.href = `${window.location.origin}/scan-settings/${scanDetails.scan_settings_id}/scans`;
        }
    }

    const viewResultText = isSafari() ? "LOGIN AND VIEW RESULT" : "VIEW RESULT";

	return (
        <div>
            <StyledContainer>		
                <StyledTitle>THANK YOU FOR SIGNING UP TO <a href="https://check1st.com" target="_blank">CHECK1ST.COM</a></StyledTitle>
                <StyledSubTitle>{`Scanning ${form.getFieldValue('rootUrl')}`} </StyledSubTitle>          
		    </StyledContainer>
            <StyledButtonContainer>
                <TrialButton id="viewResultButton" onClick={onViewResult} size="large" type="primary" htmlType="submit">
                        {viewResultText}
                </TrialButton>
			</StyledButtonContainer>
        </div>          
	)
}
export default ScanResult;
